const doc = [({"da":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"rule":({"attribute_select":({"choose_attribute":"Vælg attribut"})})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;